import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Bell } from "@phosphor-icons/react";
import { api } from "../lib/gmao";

// Campana de avisos para administradores (decisiones del cliente en ofertas, etc.). Sondeo cada 60 s.
export function NotificationBell({ compact }) {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const load = useCallback(() => api.get("/notifications").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const markAll = async () => { await api.post("/notifications/read", {}); load(); };
  const openOne = async (n) => { if (!n.read) { await api.post("/notifications/read", { ids: [n.id] }); load(); } setOpen(false); };
  return (
    <div className="relative" ref={ref}>
      <button type="button" onClick={() => setOpen((o) => !o)} className={`relative flex items-center gap-2 rounded-sm transition-all ${compact ? "p-1 text-slate-200 hover:text-white" : "w-full px-3 py-2 text-sm text-slate-400 hover:text-white hover:bg-slate-800"}`} data-testid="notifications-bell">
        <Bell size={compact ? 20 : 16} />
        {!compact && <span>Avisos</span>}
        {data.unread > 0 && <span className={`absolute ${compact ? "-top-1 -right-1" : "right-3 top-1.5"} min-w-[18px] h-[18px] px-1 rounded-full bg-orange-500 text-white text-[10px] font-bold flex items-center justify-center`} data-testid="notifications-unread">{data.unread}</span>}
      </button>
      {open && (
        <div className={`absolute z-50 w-80 max-h-96 overflow-y-auto bg-white text-slate-800 border border-slate-200 rounded-sm shadow-xl ${compact ? "right-0 top-9" : "left-full bottom-0 ml-2"}`} data-testid="notifications-panel">
          <div className="flex items-center justify-between px-3 py-2 border-b border-slate-100 text-xs">
            <span className="font-semibold">Avisos</span>
            {data.unread > 0 && <button type="button" onClick={markAll} className="text-blue-600 hover:underline" data-testid="notifications-mark-all">Marcar todos como leídos</button>}
          </div>
          {data.items.map((n) => (
            <Link key={n.id} to={n.link || "/ofertas"} onClick={() => openOne(n)} className={`block px-3 py-2 border-b border-slate-100 hover:bg-slate-50 ${n.read ? "opacity-60" : ""}`} data-testid={`notification-${n.id}`}>
              <div className="text-xs font-semibold text-slate-900">{n.titulo}</div>
              <div className="text-[11px] text-slate-600 mt-0.5">{n.texto}</div>
              <div className="text-[10px] text-slate-400 font-mono mt-0.5">{n.created_at?.slice(0, 16).replace("T", " ")}</div>
            </Link>
          ))}
          {!data.items.length && <div className="px-3 py-6 text-center text-xs text-slate-400">Sin avisos.</div>}
        </div>
      )}
    </div>
  );
}
